export default {"src":"/_next/static/media/engaging-activity.40514ce2.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};